<template>
  <div class="c-multiple-avatars">
    <c-avatar
      v-for="user in someAvatars"
      v-bind="$attrs"
      data-testid="avatar-user"
      :key="user.id"
      :src="user.src"
      :name-placeholder="user.namePlaceholder"
      :is-active-user="user.isActiveUser"
      :hide-tooltip="hideTooltip"
      :size="size"
      class="-custom-border"
    />

    <c-avatar
      v-bind="$attrs"
      v-if="showResume"
      data-testid="resume-section"
      v-tooltip.dark="{
        value: resumeAvatars.tooltip,
        hide: hideTooltip,
        isHTML: hasResumeTooltip,
        maxWidth: hasResumeTooltip ? 300 : undefined,
      }"
      :bypassed-name-placeholder="resumeAvatars.namePlaceholder"
      :size="size"
      hide-tooltip
      class="-custom-border"
    />
  </div>
</template>

<script>
import CAvatar from '@convenia/components/CAvatar'
import { tooltip } from '@convenia/components/directives'

export default {
  name: 'CMultipleAvatars',
  components: {
    CAvatar
  },
  directives: { tooltip },

  props: {
    usersAvatar: {
      type: Array,
      default: () => ([]),
      required: true
    },

    /**
     * Number of avatars that will be visible
     */
    quantity: {
      type: Number,
      default: 3
    },

    /**
     * Number of avatars to show the resume section
     */
    numbersOfParticipantsToShowSummarySection: {
      type: Number,
      default: 3
    },

    hideTooltip: Boolean,

    /**
     * How many people exist beyond `usersAvatar` (e.g. when the backend only
     * sends some of them). They are added to the resume count, which is shown
     * whenever there is someone left to count.
     */
    extraCount: {
      type: Number,
      default: 0
    },

    /**
     * Custom HTML tooltip of the resume avatar, replacing the default comma
     * separated list of the hidden names.
     */
    resumeTooltip: {
      type: String,
      default: ''
    },

    size: {
      type: Number,
      default: 40
    }
  },

  computed: {
    someAvatars () {
      const { usersAvatar } = this
      return usersAvatar.slice(0, this.quantity)
    },

    resumeAvatars () {
      const { usersAvatar } = this
      const resume = usersAvatar.slice(this.quantity)
      const concatenatedNames = resume.map(avatar => {
        const name = avatar.namePlaceholder
        return avatar.isActiveUser ? name : `${name} (desativado)`
      }).join(', ')

      const sizeAvatar = resume.length + this.extraCount
      return {
        tooltip: this.hasResumeTooltip ? this.resumeTooltip : concatenatedNames,
        namePlaceholder: `+${sizeAvatar}`
      }
    },

    hasResumeTooltip () {
      return (this.resumeTooltip || '').trim().length > 0
    },

    showResume () {
      return this.usersAvatar.length > this.numbersOfParticipantsToShowSummarySection
        || this.extraCount > 0
    }
  }
}
</script>

<style lang="scss">
.c-multiple-avatars {
  display: flex;
  align-items: center;

  & > .c-avatar.-custom-border {
    box-shadow: 0 0 0 2px #ffffff;
  }

  & > .c-avatar + .c-avatar {
    margin-left: -15px;
  }
}
</style>
